import React from 'react'

import { IContest } from 'protos'

import List, { ListProps } from '@material-ui/core/List'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'

import Event from 'components/Event'

interface Props extends ListProps {
  contests: IContest[]
  onClaim?: (contestId: string, email?: string) => void
}

const styles = (theme: Theme) => createStyles({
  item: {
    backgroundColor: theme.palette.accent.main,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const EventList: React.SFC<InjectedProps> = ({ classes, contests, onClaim, ...props }) => {
  return (
    <List style={{ padding: 0 }} {...props}>
      {contests.map(contest => (
        <Event
          to={`/events/${contest.contestId}`}
          key={`contest-${contest.contestId}`}
          className={classes.item}
          contest={contest}
          onClaim={onClaim}
        />
      ))}
    </List>
  )
}

export default withStyles(styles)(EventList)
